module.exports = {
  TOGGLE_REFRESH_TIMER: 'TOGGLE_REFRESH_TIMER',
};
